export type { LoginConsentAction } from './login-consent';
export { loginConsentAction, LOGIN_CONSENT } from './login-consent';
